import { Component, Input, OnInit } from '@angular/core';

import { map, Observable } from 'rxjs';
import { difference } from 'underscore';

import { Theme } from '../../models/theme.model';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ThemeService } from '../../services/theme.service';
import { MediaSubscription } from '../../../../Monitor/Shared/models/media-subscription.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';


@Component({
    selector: 'agpr-add-agents-to-theme-dialog',
    templateUrl: './add-agents-to-theme-dialog.component.html',
    styleUrls: ['./add-agents-to-theme-dialog.component.scss'],
    standalone: false
})
export class AddAgentsToThemeDialogComponent extends AbstractDialogComponent implements OnInit {

    @Input() agentsToAdd: MediaSubscription[] = [];

    themeList$: Observable<Theme[]>;
    selectedTheme: Theme;
    themeReachLimit: boolean = false;

    readonly id: string = 'addAgentToThemeDialog';
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public coreDialogService: CoreDialogService,
        private themeService: ThemeService,
    ) {
        super(coreDialogService, 'AddAgentsToTheme');
    }

    ngOnInit() {
        this.themeList$ = this.themeService.all$.pipe(
            map(themes => themes.filter(theme => theme.subscriptionIds.length < Theme.MAX_NUM_AGENTS))
        );
    }

    addAgentsToTheme() {
        const uniqueAgentIdsToAdd = difference(this.agentsToAdd.map(x => x.id), this.selectedTheme.subscriptionIds);

        this.selectedTheme.subscriptionIds.push(...uniqueAgentIdsToAdd);

        this.themeService.update(this.selectedTheme).subscribe({
            next: () => this.closeDialog(true),
            error: () => this.closeDialog(false)
        });
        this.closeDialog(false);
    }

    selectTheme() {
        this.themeReachLimit = (this.selectedTheme.subscriptionIds.length + this.agentsToAdd.length) > Theme.MAX_NUM_AGENTS;
    }
}
